const contact = {
    init() {
		console.log("initcontact")
        this.initEvent();
    },

    initEvent() {
        jQuery(document).on('submit', '.js-contact-form', this.handleFormSubmit.bind(this));
    },

	handleFormSubmit(e) {
		e.preventDefault();

		let name = jQuery('#name').val();
		let subject = jQuery('#object').val();
		let email = jQuery('#email').val();
		let company = jQuery('#entreprise').val();
		let message = jQuery('#message').val();

		jQuery.ajax({
			url: ajaxurl,
			type: 'POST',
			data: {
				action: 'contact_form',
				name: name,
				subject: subject,
				email: email,
				company: company,
				message: message
			},
			success: function(data) {
				let response = JSON.parse(data);
				if (response.success) {
					jQuery('.js-contact-log').text('Votre message a bien été envoyé !');

					jQuery('#name').val('');
					jQuery('#email').val('');
					jQuery('#entreprise').val('');
					jQuery('#message').val('');
				} else {
					jQuery('.js-contact-log').text('Une erreur est survenue, veuillez réessayer plus tard.');
				}
			}
		});
    },
}

contact.init();